export enum CampaignBuilderModes {
  CampaignBuilder = "CampaignBuilder",
  ProfileBuilder = "ProfileBuilder",
  AudienceBuilder = "AudienceBuilder"
}
